import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import BranchOfficeDeposits from "../components/SOD/BranchOfficeDeposits/BranchOfficeDeposits";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateSort: (sortField: string, sortDirection: string) => {
      dispatch(actions.updateSortOrder(sortField, sortDirection));
    },
    updateSearch: (searchField: string, value: string) => {
      dispatch(actions.updateSearch(searchField, value));
    },
    updateFilter: (filterField: string, value: string | string[]) => {
      dispatch(actions.updateFilter(filterField, value));
    },
    updateUi: (uiField: string, value: KeyValue[] | boolean | KeyValue) => {
      dispatch(actions.updateUi(uiField, value));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BranchOfficeDeposits);
